/* assets/label-left-panel-viewer.js
   • Клика по ячейке  — как раньше, с глич-анимацией.
   • NEW:  window.setLabelImage(href)  — программная смена изображения
           (используется «Suprise me» и любым другим скриптом).
   • currentHref всегда синхронизирован, поэтому при замене SVG-шаблона
     выбранная картинка автоматически переносится. */

(function () {
  const XLINK_NS = 'http://www.w3.org/1999/xlink';
  const IMG_SEL  = 'image[id$="placeholder" i]';

  let currentHref = null;           // последний выбранный пользователем / скриптом
  let placeholder = null;           // <image …Placeholder>

  /* ────────── apply helper ────────── */
  function applyHref(href) {
    if (!placeholder || !href) return;
    placeholder.setAttributeNS(XLINK_NS, 'href', href);
    placeholder.setAttribute('href', href);
  }

  /* ────────── public setter ────────── */
  window.setLabelImage = function (href) {
    currentHref = href;
    applyHref(href);
  };

  document.addEventListener('DOMContentLoaded', () => {
    const hostG  = document.getElementById('imported-Label');
    const cellsG = document.getElementById('CellsContainerLeft');
    if (!hostG || !cellsG) return;

    /* ────── observe svg replacements ────── */
    function updatePlaceholder() {
      const svg = hostG.querySelector('svg');
      placeholder = svg ? svg.querySelector(IMG_SEL) : null;
      applyHref(currentHref);               // переносим выбор в новое SVG
    }
    new MutationObserver(updatePlaceholder)
      .observe(hostG, { childList: true, subtree: true });
    updatePlaceholder();                    // первичный вызов

    /* ────── click on thumbnail cell ────── */
    cellsG.addEventListener('click', ev => {
      if (!placeholder) return;
      const cell  = ev.target.closest('g[id^="CellLeft"]');
      if (!cell)  return;

      const timg  = cell.querySelector('image.dynamic') || cell.querySelector('image');
      if (!timg)  return;

      const href = timg.getAttributeNS(XLINK_NS, 'href') || timg.getAttribute('href');
      if (!href) return;

      currentHref = href;                   // запоминаем
      new Image().src = href;               // hint: preload

      /* glitch effect ---------------------------------------------------- */
      const tf  = placeholder.getAttribute('transform') || '';
      const m   = tf.match(/translate\(\s*([-\d.]+)[ ,]([-\d.]+)\)/);
      const ox  = m ? +m[1] : 0,  oy = m ? +m[2] : 0, tail = m ? tf.slice(m[0].length) : '';

      let f = 0, TOTAL = 16, SW = 8, DELAY = 25;
      (function step() {
        if (f === SW) {                      // середина — меняем картинку
          applyHref(href);
          placeholder.style.filter = '';
        }
        if (f >= TOTAL) {
          if (m) placeholder.setAttribute('transform', `translate(${ox} ${oy})${tail}`);
          placeholder.style.filter = '';
          return;
        }
        const dx = (Math.random()*2-1)*3, dy = (Math.random()*2-1)*3;
        if (m) placeholder.setAttribute('transform',
          `translate(${(ox+dx).toFixed(2)} ${(oy+dy).toFixed(2)})${tail}`);

        const hue = (Math.random()*2-1)*90,
              blur= Math.random()*3,
              sat = 50+Math.random()*250;
        placeholder.style.filter =
          `hue-rotate(${hue.toFixed(1)}deg) blur(${blur.toFixed(2)}px) saturate(${sat.toFixed(0)}%)`;

        f++; setTimeout(step, DELAY);
      })();
    }, { passive:true });
  });
})();
